import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './LeadingRehabCompany.css';

const LeadingRehabCompany = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://primerehabindustries.in/Image/Logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "description": "Prime Rehab Industries is a leading rehabilitation equipment company in Tamil Nadu, manufacturing clinically engineered physiotherapy and rehabilitation equipment for hospitals, clinics, and therapy centres across India.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "url": "https://www.primerehabindustries.in",
          "sameAs": [
            "https://www.google.com/maps/search/?api=1&query=Prime+Rehab+Industries%2C+Plot+No+4%2C+Kandasamy+Nagar+Annex%2C+Vanagaram%2C+Chennai+600095"
          ],
          "areaServed": ["Tamil Nadu", "India"],
          "openingHours": "Mo-Sa 09:00-18:00"
        },
        {
          "@type": "Product",
          "name": "Unweighing System",
          "description": "Motorized DC unweighing system for standing and gait rehabilitation training. Features a hanging scale with digital weight display, safety harness support, SS pipe standing and walking hand support, and optional treadmill attachment. Height 231 cm.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What makes Prime Rehab Industries a leading rehabilitation equipment company in Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries leads in Tamil Nadu through end-to-end in-house manufacturing, a comprehensive range of 100+ equipment models, 12+ years of focused rehabilitation engineering, and over 1,000 successful installations across India. Their equipment covers physiotherapy, chiropractic, orthopaedic, neurological, and paediatric rehabilitation."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries manufacture all its rehabilitation equipment in-house?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries manufactures all its rehabilitation equipment in-house. This gives them direct control over build quality, engineering precision, and material selection — resulting in durable, clinically reliable products that meet the demands of daily hospital and clinic use."
              }
            },
            {
              "@type": "Question",
              "name": "How many rehabilitation equipment models does Prime Rehab Industries offer?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries offers over 100 rehabilitation equipment models covering treatment tables, traction tables, tilting tables, Bobath tables, chiropractic tables, unweighing systems, and more. Custom sizes are also available on request for clinics and hospitals with specific requirements."
              }
            },
            {
              "@type": "Question",
              "name": "Is Prime Rehab Industries equipment suitable for neurological rehabilitation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries manufactures equipment specifically designed for neurological rehabilitation, including the High Low Bobath Table for neuro therapy, the High Low Tilting Table with harness support for positioning, and the Unweighing System for gait and standing rehabilitation."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Leading Rehabilitation Equipment Company in Tamil Nadu",
              "item": "https://www.primerehabindustries.in/blog/leading-rehabilitation-equipment-company-tamil-nadu"
            }
          ]
        }
      ]
    };

    document.title = "Leading Rehab Equipment Company Tamil Nadu | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab Industries is a leading rehabilitation equipment company in Tamil Nadu with 12+ years, 100+ models, and 1,000+ installations across India.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/leading-rehabilitation-equipment-company-tamil-nadu";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="editorial-layout-page">
      <Navbar />

      {/* Hero Section - Full Screen Magazine Style */}
      <section className="editorial-hero">
        <div className="editorial-hero-bg" style={{ backgroundImage: `url('https://primerehabindustries.in/Image/Product/Pro3.png')` }}></div>
        <div className="editorial-hero-overlay"></div>
        <div className="editorial-hero-content">
          <span className="editorial-tag">Rehabilitation Equipment Guide</span>
          <h1>Leading Rehabilitation Equipment Company in Tamil Nadu</h1>
          <p className="editorial-hero-sub">
            Prime Rehab Industries Unweighing System — Trusted by 500+ Clinics Across India
          </p>
        </div>
      </section>

      {/* Intro Section - Two Column Text */}
      <section className="editorial-intro">
        <div className="editorial-container">
          <div className="editorial-intro-grid">
            <div className="editorial-intro-left">
              <h2>Rehabilitation is not a single treatment. It's a journey.</h2>
            </div>
            <div className="editorial-intro-right">
              <p>
                A patient recovering from a stroke, a fracture, or a spinal injury needs equipment that moves with them through every stage of that journey. And the clinics and hospitals guiding those patients need a company behind them that truly understands what clinical rehabilitation demands.
              </p>
              <p>
                Prime Rehab Industries has spent over 12 years building that understanding into every product it manufactures. With 100+ equipment models, 1,000+ installations, and a presence in 500+ clinics and hospitals across India, the company has established itself as one of Tamil Nadu's leading names in rehabilitation equipment not just as a supplier, but as a manufacturing partner that healthcare professionals trust.
              </p>
            </div>
          </div>

          <div className="editorial-highlight-box">
            <h3>What Defines a Leading Rehabilitation Equipment Company</h3>
            <p>
              The difference between a leading company and an average one shows up in the details. It's in the smoothness of a motorized height mechanism after three years of daily use. It's in the durability of rexine upholstery that holds its shape through hundreds of patient sessions. It's in the precision of a traction lock that holds firmly without slipping. A leading rehabilitation equipment company doesn't just sell products. It engineers solutions and stands behind them long after delivery.
            </p>
          </div>
        </div>
      </section>

      {/* Vertical Steps / Timeline Style for How Prime Rehab Leads */}
      <section className="editorial-steps">
        <div className="editorial-container">
          <h2 className="section-title-elegant">How Prime Rehab Industries Leads in Tamil Nadu</h2>
          
          <div className="step-timeline">
            <div className="step-item">
              <div className="step-number">01</div>
              <div className="step-content">
                <h4>End-to-End In-House Manufacturing</h4>
                <p>Every piece of equipment Prime Rehab produces is designed and manufactured in house. There are no third-party assemblies, no imported generic components rebranded and resold. The frames are welded in house, the mechanisms are assembled in house, and the upholstery is fitted in house. That level of control is what makes the difference between equipment that lasts a year and equipment that lasts a decade.</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">02</div>
              <div className="step-content">
                <h4>A Comprehensive Range of 100+ Equipment Models</h4>
                <p>From spinal decompression tables to motorized gait training systems, Prime Rehab's range covers every branch of modern rehabilitation. Clinics don't need to source different products from different vendors. Browse the complete range on the products page or download the product catalogue for full technical specifications.</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">03</div>
              <div className="step-content">
                <h4>12+ Years of Focused Rehabilitation Engineering</h4>
                <p>Twelve years of manufacturing physiotherapy and rehabilitation equipment means Prime Rehab has refined every product through real clinical feedback. Tables that therapists actually use. Mechanisms that work under real patient loads. Upholstery selected for clinical hygiene as much as comfort. That accumulated expertise is what separates a specialist manufacturer from a general equipment supplier.</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">04</div>
              <div className="step-content">
                <h4>1,000+ Successful Installations Across India</h4>
                <p>With over 1,000 installations completed across India, Prime Rehab Industries has proven its reliability at scale. Small clinics with one or two treatment tables, large hospital rehabilitation departments with complete equipment setups the company has delivered across every size and configuration. Each installation is a reference point for the quality of the products and the professionalism of the team.</p>
              </div>
            </div>

            <div className="step-item">
              <div className="step-number">05</div>
              <div className="step-content">
                <h4>Equipment for Every Branch of Rehabilitation</h4>
                <p>Prime Rehab Industries designs equipment for physiotherapy, chiropractic, orthopaedic, neurological, and paediatric rehabilitation. This breadth means a clinic can grow its services adding a neurological therapy program or a gait rehabilitation suite without switching to a different equipment partner. One company, every rehabilitation need.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Massive Testimonial Display */}
      <section className="editorial-massive-quote">
        <div className="editorial-container">
          <blockquote>
            "Prime Rehab's unweighing system has transformed our gait rehabilitation program. The build quality is excellent and the motorized lift is smooth and reliable for daily patient use."
          </blockquote>
          <div className="quote-author-block">
            <strong>Dr. Senthil Kumar</strong>
            <span>Rehabilitation Specialist, Tamil Nadu</span>
          </div>
        </div>
      </section>

      {/* Staggered Cards for Equipment Categories */}
      <section className="editorial-equipment">
        <div className="editorial-container">
          <h2 className="section-title-elegant centered">Rehabilitation Equipment Categories from Prime Rehab</h2>
          
          <div className="staggered-grid">
            <div className="staggered-card">
              <div className="card-indicator"></div>
              <h4>1. Spinal and Traction Therapy Equipment</h4>
              <p>The SPINETHERA DTS Table is purpose-built for spinal decompression therapy, with a traction lock system, adjustable arm rests, and gas spring support. The High Low Traction Table adds electric height adjustment and a backrest angle of up to 60 degrees covering a wide range of spinal and musculoskeletal treatment protocols.</p>
            </div>
            
            <div className="staggered-card translate-y">
              <div className="card-indicator"></div>
              <h4>2. Neurological Rehabilitation Tables</h4>
              <p>The High Low Bobath Table features motorized height adjustment and a wide surface specifically designed for Bobath neuro therapy — one of the most widely used neurological rehabilitation approaches in modern physiotherapy practice. The High Low Tilting Table supports postural management with motorized tilt, harness clips, and a foot leg board adjustable from +20° to -120°.</p>
            </div>
            
            <div className="staggered-card">
              <div className="card-indicator"></div>
              <h4>3. Gait and Movement Rehabilitation Systems</h4>
              <p>The Unweighing System is Prime Rehab's most advanced product a motorized DC lifting frame with a digital hanging scale, safety harness, and SS pipe walking support for standing and gait rehabilitation. Designed for patients recovering from neurological events, major orthopaedic surgeries, or prolonged immobilisation. An optional treadmill attachment enables advanced walking rehabilitation.</p>
            </div>
            
            <div className="staggered-card translate-y">
              <div className="card-indicator"></div>
              <h4>4. Multi-Section Treatment Tables</h4>
              <p>The High Low Two Fold Table and High Low 3-Fold Table deliver versatile treatment positioning with electric height control, adjustable backrests, and a breathing face hole for prone treatment. Both are built with 2.5-inch high-density foam padding and lockable caster wheels — practical details that matter in a busy clinical environment.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Massive Quote */}
      <section className="editorial-massive-quote dark-theme">
        <div className="editorial-container">
          <blockquote>
            "We've been using Prime Rehab equipment across our rehabilitation centre for two years. The quality and engineering precision are outstanding. They are genuinely a leading company in this space."
          </blockquote>
          <div className="quote-author-block">
            <strong>Dr. Meena Subramaniam</strong>
            <span>Rehabilitation Centre Director, Chennai</span>
          </div>
        </div>
      </section>

      {/* Content Block & FAQs */}
      <section className="editorial-content-block">
        <div className="editorial-container">
          <div className="editorial-content-flex">
            <div className="content-left">
              <h3>Supplying Rehabilitation Equipment Across Tamil Nadu</h3>
              <p>
                Prime Rehab Industries is based in Chennai and supplies rehabilitation equipment to clinics, hospitals, and therapy centres across Tamil Nadu and across India. Whether you're in Chennai, Coimbatore, Madurai, Trichy, or a smaller district town, the team works with you from enquiry to installation.
              </p>
              <p>
                To discuss your clinic's requirements or request a product demonstration, visit the contact page or call directly on <strong>+91 99943 51947</strong>. For a detailed look at the full product range, the product catalogue has complete specifications for every model.
              </p>
              <div className="editorial-cta-buttons">
                <a href="/products" className="editorial-btn">Browse Catalogue</a>
                <a href="/contact" className="editorial-btn outline">Get in Touch</a>
              </div>
            </div>
            
            <div className="content-right">
              <h3>Frequently Asked Questions</h3>
              <div className="elegant-faq-list">
                <div className="elegant-faq">
                  <h6>What makes Prime Rehab Industries a leading rehabilitation equipment company in Tamil Nadu?</h6>
                  <p>Prime Rehab Industries leads in Tamil Nadu through end to end in house manufacturing, a comprehensive range of 100+ equipment models, 12+ years of focused rehabilitation engineering, and over 1,000 successful installations across India. Their equipment covers physiotherapy, chiropractic, orthopaedic, neurological, and paediatric rehabilitation.</p>
                </div>
                <div className="elegant-faq">
                  <h6>Does Prime Rehab Industries manufacture all its rehabilitation equipment in house?</h6>
                  <p>Yes. Prime Rehab Industries manufactures all its rehabilitation equipment in house. This gives them direct control over build quality, engineering precision, and material selection resulting in durable, clinically reliable products that meet the demands of daily hospital and clinic use.</p>
                </div>
                <div className="elegant-faq">
                  <h6>How many rehabilitation equipment models does Prime Rehab Industries offer?</h6>
                  <p>Prime Rehab Industries offers over 100 rehabilitation equipment models covering treatment tables, traction tables, tilting tables, Bobath tables, chiropractic tables, unweighing systems, and more. Custom sizes are also available on request for clinics and hospitals with specific requirements.</p>
                </div>
                <div className="elegant-faq">
                  <h6>Is Prime Rehab Industries equipment suitable for neurological rehabilitation?</h6>
                  <p>Yes. Prime Rehab Industries manufactures equipment specifically designed for neurological rehabilitation, including the High Low Bobath Table for neuro therapy, the High Low Tilting Table with harness support for positioning, and the Unweighing System for gait and standing rehabilitation.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clean Footer CTA */}
      <section className="editorial-bottom-cta">
        <div className="editorial-container">
          <h2>Partner with Tamil Nadu's Leading Rehabilitation Equipment Company</h2>
          <p>
            With 12+ years of in-house manufacturing, 1,000+ installations, and equipment trusted across every branch of rehabilitation, Prime Rehab Industries is the partner Tamil Nadu clinics rely on. Reach the team to discuss your specific clinical requirements.
          </p>
          <div className="bottom-cta-actions">
            <a href="tel:+919994351947" className="editorial-btn large">Call +91 99943 51947</a>
            <a href="https://www.google.com/maps/search/?api=1&query=Prime+Rehab+Industries%2C+Plot+No+4%2C+Kandasamy+Nagar+Annex%2C+Vanagaram%2C+Chennai+600095" target="_blank" rel="noopener noreferrer" className="editorial-btn large outline">Find Us on Google Maps</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LeadingRehabCompany;
